module.exports = __webpack_public_path__ + "img/shuixi14.219f30c1.png";